import { Select } from 'antd'
import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'

const DropdownStyles = createGlobalStyle`
  .damage-types-dropdown {
    .ant-select-item {
      font-size: 0.75rem !important;
    }

    .ant-select-item-option-content {
      font-size: 0.75rem !important;
    }

    .ant-select-item-group {
      font-size: 0.75rem !important;
      font-weight: 600 !important;
    }
  }
`

const StyledSelect = styled(Select)`
  width: 100%;
  font-size: 0.75rem;

  .ant-select-selector {
    background-color: #000000 !important;
    border-color: #666666 !important;
    color: white !important;
    min-height: 32px;
    height: auto !important;
    font-size: 0.75rem !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
    font-size: 0.75rem !important;
  }

  .ant-select-selection-item {
    color: white !important;
    background-color: #2e7d32 !important;
    border-color: #4caf50 !important;
    font-size: 0.75rem !important;
  }

  .ant-select-arrow {
    color: rgba(255, 255, 255, 0.6) !important;
  }
`

interface DamageTypesSelectProps {
  value: string[]
  onChange: (value: unknown) => void
  groupedOptions: Array<{
    label: string
    options: Array<{ label: string; value: string }>
  }>
  placeholder?: string
}

export const DamageTypesSelect: React.FC<DamageTypesSelectProps> = ({
  value,
  onChange,
  groupedOptions,
  placeholder = 'Add more damage types...',
}) => {
  const handleDropdownVisibleChange = (open: boolean) => {
    if (open) {
      // Reset dropdown scroll position when opening
      requestAnimationFrame(() => {
        const dropdown = document.querySelector(
          '.damage-types-dropdown .rc-virtual-list-holder'
        )
        if (dropdown) {
          dropdown.scrollTop = 0
        }
      })
    }
  }

  return (
    <>
      <DropdownStyles />
      <StyledSelect
        mode='multiple'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={groupedOptions}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        allowClear
        popupClassName='damage-types-dropdown'
        onDropdownVisibleChange={handleDropdownVisibleChange}
      />
    </>
  )
}
